import Heading from './../components/Heading';
import SmallHeading from './../components/SmallHeading';
import DetailsHeading from './../components/DetailsHeading';
import Stepper from './../components/Stepper';
import Steps from './../assets/Svgs/steps.svg';

function HowItWorkSection() {
  return (
    <section className='bg-emerald-50 shadow-md pb-10'>
      <SmallHeading name="How It Works" tstyle="text-center my-1 mt-10 pt-10" />
      <Heading name="Supporting Your Goals Every Step of the Way" tstyle="text-center my-1" />
      <div className='mt-4 px-4 md:px-10'>
        <DetailsHeading 
          name="Follow these easy steps to utilize our professional services and ensure your business success" 
          tstyle="my-1 text-center"
        />
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center mt-10">
        {/* Left Half - Image */}
        <div className="flex-1 flex justify-center mb-8 md:mb-0">
          <img
            className="w-3/4 md:w-full h-56 cursor-pointer transition-transform duration-300 transform hover:scale-105"
            src={Steps}
            alt="Steps"
          />
        </div>

        {/* Right Half - Stepper */}
        <div className="flex-1 flex justify-center">
          <Stepper />
        </div>
      </div>    
    </section>
  );
}

export default HowItWorkSection;
